import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";

/**
 * Posts can be added here.
 * You can add default posts of your wish with different attributes
 * */

export const posts = [
  {
    _id: uuid(),
    id:101,
    content: "I snap!",
    likes: {
      likeCount: 4,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Tony",
    lastName: "Stark",
    username: "tonyStark",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [], 
    img: "https://culturedvultures.com/wp-content/uploads/2016/11/18375601324_cacd540a4d_z.jpg",
  },
  {
    _id: uuid(),
    id:102,
    content: "I am Ironman!! 🔥",
    likes: {
      likeCount: 5,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Tony",
    lastName: "Stark",
    username: "tonyStark",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "",
  },
  {
    _id: uuid(),
    id:103,
    content: "Get ready to redefine heroism ! ",
    likes: {
      likeCount: 3,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Tony",
    lastName: "Stark",
    username: "tonyStark",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i.ytimg.com/vi/5Rb9hAHifFA/sddefault.jpg",
  },
  {
    _id: uuid(),
    id:201,
    content:
      "Chasing dreams and capturing moments ✨",
    likes: {
      likeCount: 11,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Kim",
    lastName: "Taehyung",
    username: "thv",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://64.media.tumblr.com/1875c3066878568b1fd62c32c6a70f5d/be6416e10e193b59-68/s500x750/bd4731257410320d74cc3a7d2fd22498763b683a.jpg",
  },
  {
    _id: uuid(),
    id:202,
    content:
      "I see you smile, I smile too✨",
    likes: {
      likeCount: 8,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Kim",
    lastName: "Taehyung",
    username: "thv",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-wYTFRpJhwEUvQmoe-BWxXPg-t500x500.jpg",
  },
    {
    _id: uuid(),
    id:203,
    content:
      "Come travel with me✨",
    likes: {
      likeCount: 10,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Kim",
    lastName: "Taehyung",
    username: "thv",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-GfCjetpZgu9PvzJz-ghGg4w-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:301,
    content:"In a world of color, I found solace in shades of black and white.",
    likes: {
      likeCount: 15,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Jeon",
    lastName: "Jungkook",
    username: "jungkook",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-cLUUzw4jZwpWOIxG-zMyQ6w-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:302,
    content:"Borahae",
    likes: {
      likeCount: 12,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Jeon",
    lastName: "Jungkook",
    username: "jungkook",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-0HMDXfNGFyftCkDv-PGPuvw-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:303,
    content:"Eat. Sleep. Repeat",
    likes: {
      likeCount: 10,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Jeon",
    lastName: "Jungkook",
    username: "jungkook",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-xHEzGQ7yhK14hykX-yI8BCg-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:401,
    content: "Lost in the art of simplicity ✨",
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Lee",
    lastName: "Ji-eun",
    username: "your-IU",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-KBwCz2KUpOaVcIMB-Rv18mQ-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:402,
    content: "",
    likes: {
      likeCount: 6,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Lee",
    lastName: "Ji-eun",
    username: "your-IU",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-000276252464-rv0qci-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:501,
    content:"Life is short. Smile while you still have teeth!" ,
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Ahn",
    lastName: "Hye-jin",
    username: "Hwasa",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i.pinimg.com/564x/33/ec/d6/33ecd65070d76565e958302f0bbbb6b4.jpg ",
  },
  {
    _id: uuid(),
    id:502,
    content:"watermelon sugar High!!" ,
    likes: {
      likeCount: 8,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Ahn",
    lastName: "Hye-jin",
    username: "Hwasa",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://i1.sndcdn.com/artworks-8HLrRO1Xi679ybzh-Oi992Q-t500x500.jpg",
  },
  {
    _id: uuid(),
    id:503,
    content:"" ,
    likes: {
      likeCount: 12,
      likedBy: [],
      dislikedBy: [],
    },
    firstName: "Ahn",
    lastName: "Hye-jin",
    username: "Hwasa",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    comment: [],
    following: [],
    followers: [],
    img: "https://64.media.tumblr.com/5e3efcb16efc58716efb447dbda5f4a2/tumblr_oytxf73ZeV1ugqszxo1_r1_500.jpg ",
  },
];
